"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));
var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _warning = _interopRequireDefault(require("warning"));
var _BubbleLoader = _interopRequireDefault(require("./BubbleLoader"));
var _BouncyLoader = _interopRequireDefault(require("./BouncyLoader"));
var _styled = _interopRequireDefault(require("../styled"));
var _excluded = ["duration", "color", "size", "small", "large", "center", "type"];
var _templateObject;
var LoadingWrapper = _styled.default.div(_templateObject || (_templateObject = (0, _taggedTemplateLiteralLoose2.default)(["\n  background: none;\n"])));
var LoadingIndicator = function LoadingIndicator(_ref) {
  var duration = _ref.duration,
    color = _ref.color,
    size = _ref.size,
    small = _ref.small,
    large = _ref.large,
    center = _ref.center,
    type = _ref.type,
    props = (0, _objectWithoutPropertiesLoose2.default)(_ref, _excluded);
  (0, _warning.default)(!small, '[LoadingIndicator] `small` is deprecated. Use `size="small"` instead.');
  (0, _warning.default)(!large, '[LoadingIndicator] `large` is deprecated. Use `size="large"` instead.');
  var useType = 'bubble';
  if (type) {
    useType = 'bouncy';
  }
  return /*#__PURE__*/_react.default.createElement(LoadingWrapper, props, useType === 'bubble' && /*#__PURE__*/_react.default.createElement(_BubbleLoader.default, {
    duration: duration,
    color: color,
    center: center,
    size: size || small && 'small' || large && 'large' || null
  }), useType === 'bouncy' && /*#__PURE__*/_react.default.createElement(_BouncyLoader.default, {
    duration: duration,
    color: color,
    center: center,
    size: size || small && 'small' || large && 'large' || null
  }));
};
LoadingIndicator.defaultProps = Object.assign({}, _BubbleLoader.default.defaultProps, {
  small: null,
  large: null,
  center: null,
  type: null
});
var _default = exports.default = LoadingIndicator;